module.exports = __webpack_public_path__ + "static/img/hqyz.1b857ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cooperation/hqyz.png
// module id = ksp2
// module chunks = 36